import Reveal from "@/components/Reveal";
import { CONTENT } from "@/content";

const CHAPTERS = [
  {
    num: "01",
    title: "Écouter",
    text: "Chaque corps raconte une histoire. La séance commence toujours par un temps d'échange : vos antécédents, votre quotidien, ce que votre corps exprime — avant tout geste technique.",
  },
  {
    num: "02",
    title: "Comprendre",
    text: "Plutôt que de masquer le symptôme, je recherche sa cause : posture, stress, ancienne blessure, rythme de vie. Le corps est un tout, chaque tension a une origine.",
  },
  {
    num: "03",
    title: "Accompagner",
    text: "La séance ne s'arrête pas à la porte du cabinet. Conseils personnalisés, exercices simples et pédagogie vous aident à prolonger les bienfaits au quotidien.",
  },
];

const Approach = () => (
  <section id="approche" className="grain relative overflow-hidden bg-ivory py-28 md:py-36" data-testid="approach-section">
    <div aria-hidden="true" className="wash wash-sage blob -right-[10%] top-[8%] h-[520px] w-[520px]" />
    <div aria-hidden="true" className="wash wash-beige blob-alt -left-[12%] bottom-[4%] h-[480px] w-[480px]" style={{ animationDelay: "-13s" }} />
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <p className="text-xs font-medium uppercase tracking-[0.28em] text-gold" data-testid="approach-overline">
              Mon approche
            </p>
            <h2 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-anthracite md:text-5xl">
              Une ostéopathie qui prend le temps de <em className="text-sage-dark">comprendre</em>
            </h2>
            <div className="gold-rule mt-8 w-24" />
            <p className="mt-8 max-w-sm text-base font-light leading-relaxed text-taupe">
              Diplômée D.O., je pratique une ostéopathie douce et globale, sans
              manipulation forcée. Mon rôle : vous soigner, mais aussi vous
              transmettre les clés de votre propre corps.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="relative mt-14 hidden lg:block">
            <div className="blob-alt absolute -left-6 -top-6 h-full w-full bg-beige/70" />
            <img
              src={CONTENT.images.approach}
              alt={CONTENT.images.approachAlt}
              loading="lazy"
              className="soft-shadow relative aspect-[5/4] w-full rounded-xl object-cover"
            />
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7 lg:pt-24">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.1}>
            <div
              data-testid={`approach-chapter-${c.num}`}
              className="group grid grid-cols-[auto_1fr] gap-8 border-t border-sage-light/60 py-12 transition-colors duration-500 first:border-t-0 first:pt-0 md:gap-14"
            >
              <span className="font-serif text-5xl font-light text-sage-light transition-colors duration-500 group-hover:text-gold md:text-6xl">
                {c.num}
              </span>
              <div>
                <h3 className="font-serif text-2xl font-light italic text-anthracite md:text-3xl">{c.title}</h3>
                <p className="mt-4 max-w-xl text-base font-light leading-relaxed text-taupe">{c.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Approach;
